import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IDatasets, StudyFamily } from '../interfaces/i-datasets';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  getDatasets(): Observable<IDatasets[]> {
    return this.http.get<IDatasets[]>(environment.baseUrl + 'manhattan/datasets');
  }

  // Datasets are grouped by study family (gwas15 / gwas16 / v3), not by reference genome —
  // GWAS 1-6 and v3 are both GRCh38, so genome alone cannot tell the two studies apart.
  getDatasetsByFamily(family: StudyFamily): Observable<IDatasets[]> {
    return this.http.get<IDatasets[]>(
      environment.baseUrl + 'manhattan/datasets?study_family=' + family
    );
  }

  getGwas15Datasets(): Observable<IDatasets[]> {
    return this.getDatasetsByFamily('gwas15');
  }

  getGwas16Datasets(): Observable<IDatasets[]> {
    return this.getDatasetsByFamily('gwas16');
  }

  getV3Datasets(): Observable<IDatasets[]> {
    return this.getDatasetsByFamily('v3');
  }

  getManhattanPlot(): Observable<string> {
    return this.http.get(environment.baseUrl + 'manhattan/plot', {
      responseType: 'text',
    });
  }
}
